"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncedData = void 0;
const react_1 = require("react");
const useDeepEqualEffect_1 = require("./useDeepEqualEffect");
const useClient_1 = require("./useClient");
const ErrorResolver_1 = require("../contexts/ErrorResolver");
const useRequiredContext_1 = require("./useRequiredContext");
function useSyncedData(syncMetadata) {
    const client = (0, useClient_1.useClient)();
    const [data, setData] = (0, react_1.useState)(undefined);
    // we use the error resolver as error boundaries just don't work
    // this is kind of an anti-pattern, as in one instance the socket error is not a UI error nor is it currently an error that can be resolved
    const { resolveError } = (0, useRequiredContext_1.useRequiredContext)(ErrorResolver_1.ErrorResolverContext);
    const handleError = (e) => {
        // trying to get the retry to work for real sockets
        // only issue is the useCallback of the handleRetry function
        // @ts-ignore
        // const syncDataFunc = client[syncMetadata.endpoint][syncMetadata.action];
        // const parameters = Object.values(syncMetadata.parameters);
        // @ts-ignore
        // const retry = () => this.useSyncedData(syncDataFunc(parameters));
        const error = {
            title: undefined,
            retry: undefined,
            approach: "inline"
        };
        resolveError(error);
        console.error(e);
    };
    // used for deep equal hook
    const syncMetadataNoFunc = Object.assign(Object.assign({}, syncMetadata), { unseralizeData: undefined });
    (0, useDeepEqualEffect_1.useDeepEqualEffect)(() => {
        const guid = client.sync.connect(syncMetadata, newData => {
            // called when the server sends data
            // error occurred getting data, so let's handle it
            if (newData instanceof Error) {
                handleError(newData);
                return;
            }
            // unseralise data, if the function is present
            if (typeof syncMetadata.unseralizeData === "function") {
                setData(syncMetadata.unseralizeData(newData));
                return;
            }
            setData(newData);
        });
        // on unmount or syncMetadataChange
        return () => {
            client.sync.disconnect(guid);
        };
    }, [syncMetadataNoFunc]);
    if (syncMetadata.mockData) {
        // TODO: when the mock socket stuff is implemented we should emit an event where the data is an error
        if (syncMetadata.mockData instanceof Error) {
            handleError(syncMetadata.mockData);
            return;
        }
        if (syncMetadata.emitter) {
            syncMetadata.emitter.on("sync_data", newData => {
                setData(newData);
            });
        }
        return syncMetadata.mockData;
    }
    return data;
}
exports.useSyncedData = useSyncedData;
//# sourceMappingURL=useSyncedData.js.map